import React from "react";
import { useParams } from "react-router-dom";
import { news } from "../data/news";

function NewsDetails() {
  const { id } = useParams();

  const article = news.find(n => n.id === parseInt(id));

  if (!article) return <h2>Article non trouvé</h2>;

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>
      <h1>{article.title}</h1>
      <p style={{ color: "#888" }}>{article.date}</p>

      <img
        src={article.image}
        alt={article.title}
        style={{
          width: "100%",
          marginTop: "20px",
          borderRadius: "15px"
        }}
      />

      <p style={{ marginTop: "30px", lineHeight: "1.8" }}>
        {article.content}
      </p>
    </div>
  );
}

export default NewsDetails;